import { createStore, combineReducers, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from '@redux-devtools/extension';
import authReducer from './reducers/authReducer';
import purchaseOrderReducer from '../containers/PurchaseOrder/reducer';
import productReducer from './reducers/productReducer';
import vendorReducer from './reducers/vendorReducer';
import homeReducer from './reducers/homeReducer';
import deliveryAddressReducer from './reducers/deliveryAddressReducer';
import udhyamCategoryReducer from './reducers/udhyamCategoryReducer';
import productCategoryReducer from './reducers/productCategoryReducer';
import firmNameReducer from './reducers/firmNameReducer';
import auditLogReducer from './reducers/auditLogReducer';
import rbacReducer from './reducers/rbacReducer';
import deliveryChallanReducer from './reducers/deliveryChallanReducer';
import billReceiptReducer from './reducers/billReceiptReducer';
import analyticsReducer from './reducers/analyticsReducer';
import paymentReducer from './reducers/paymentReducer';
import vendorPerformanceReducer from './reducers/vendorPerformanceReducer';
import approvalReducer from './reducers/approvalReducer';
import priceHistoryReducer from './reducers/priceHistoryReducer';
import quotationReducer from './reducers/quotationReducer';
import returnOrderReducer from './reducers/returnOrderReducer';
import rootSaga from './sagas';

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  orders: purchaseOrderReducer,
  products: productReducer,
  vendors: vendorReducer,
  home: homeReducer,
  deliveryAddresses: deliveryAddressReducer,
  udhyamCategories: udhyamCategoryReducer,
  productCategories: productCategoryReducer,
  firmNames: firmNameReducer,
  auditLogs: auditLogReducer,
  rbac: rbacReducer,
  deliveryChallans: deliveryChallanReducer,
  billReceipts: billReceiptReducer,
  analytics: analyticsReducer,
  payments: paymentReducer,
  vendorPerformance: vendorPerformanceReducer,
  approvals: approvalReducer,
  priceHistory: priceHistoryReducer,
  quotations: quotationReducer,
  returns: returnOrderReducer,
});

// Create store with middleware
const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);

// Run saga middleware
sagaMiddleware.run(rootSaga);

export default store;
